import React from 'react';
import { TomeFolio } from '../../../primitives/tome';

interface StatsSummaryPanelProps {
  statPoints: number;
}

export const StatsSummaryPanel: React.FC<StatsSummaryPanelProps> = ({ statPoints }) => (
  <TomeFolio className="character-stat-allocation" aria-label="Stat allocation status" shapeSeed="stats">
    <div className="character-stat-allocation__count">
      <strong>{statPoints}</strong>
      <span>{statPoints === 1 ? 'point available' : 'points available'}</span>
    </div>
    <p>
      Spend one point at a time on Strength, Dexterity, Intelligence, or Luck.
      Values and point balance update only after the server confirms the request.
    </p>
  </TomeFolio>
);
